import { AccessTime, EditOutlined, OpenInBrowser, PersonOutline } from '@lichtblick/icons';
import { Colors, TextVariants } from '@lichtblick/theme';
import { AppointmentType } from '@lichtblick/types';
import { formatTime } from '@lichtblick/utils';

import {
  AppointmentFooter,
  AppointmentLink,
  Container,
  DragHandleBar,
  DragHandleRevealZone,
  EditActionWrapper,
  EventRow,
  ItemWrapper,
  StatusDot,
  TypePill,
  TypePillLabel,
} from './InstallationCalendar.styles';
import { CalendarEvent } from './type';

import { Button, getIcon, Text } from '..';

export const CalendarAppointment = ({
  event,
  onEdit,
}: {
  event: CalendarEvent;
  onEdit?: (event: CalendarEvent) => void;
}) => {
  const isBlocker = [
    AppointmentType.Krank,
    AppointmentType.Feiertag,
    AppointmentType.Puffertag,
    AppointmentType.Schulung,
    AppointmentType.Urlaub,
    AppointmentType.BueroTag,
  ].includes(event?.type as AppointmentType);

  return (
    <Container $isBinding={event?.isBinding} $variant={event?.type}>
      {!event?.isBinding && (
        <>
          <DragHandleRevealZone />
          <DragHandleBar
            className="rbc-addons-dnd-drag-handle calendar-drag-handle"
            onClick={(e) => {
              e.stopPropagation();
            }}
          />
        </>
      )}
      <ItemWrapper>
        <TypePill>
          {getIcon(event.type ?? '')}
          <TypePillLabel $variant={TextVariants.body.xs}>{event?.type}</TypePillLabel>
        </TypePill>

        <StatusDot $isBinding={event.isBinding ?? false} />
      </ItemWrapper>
      <EventRow>
        {!isBlocker && event.workOrderId ? (
          <AppointmentLink
            href={`/pm/installation/${event.workOrderId}/appointments`}
            onClick={(e) => {
              e.stopPropagation();
            }}
            onMouseDown={(e) => {
              e.stopPropagation();
            }}
            onPointerDown={(e) => {
              e.stopPropagation();
            }}
            target="_blank"
          >
            <Text $variant={TextVariants.body.xs} color={Colors.blue['100']}>
              {event?.name}
            </Text>
            <OpenInBrowser style={{ color: Colors.blue['100'], fontSize: '16px' }} />
          </AppointmentLink>
        ) : (
          <Text $variant={TextVariants.body.xs} color="black">
            {event?.name}
          </Text>
        )}
      </EventRow>
      <AppointmentFooter>
        <ItemWrapper>
          {event?.start && (
            <>
              <AccessTime fontSize="small" />
              <Text $variant={TextVariants.body.xs}>{formatTime(event.start.toISOString())}</Text>
            </>
          )}
          {event?.teamName && (
            <>
              <PersonOutline fontSize="small" />
              <Text $variant={TextVariants.body.xs}>{event?.teamName}</Text>
            </>
          )}
        </ItemWrapper>
        <EditActionWrapper
          onMouseDown={(e) => {
            e.stopPropagation();
          }}
          onPointerDown={(e) => {
            e.stopPropagation();
          }}
        >
          <Button
            icon={<EditOutlined />}
            label="Edit"
            onClick={(input) => {
              input?.stopPropagation();
              onEdit?.(event);
            }}
            size="small"
            variant="secondary"
          />
        </EditActionWrapper>
      </AppointmentFooter>
    </Container>
  );
};
